import {useSelector} from 'react-redux';

export default function TranslationLabel({id, defaultValue}) {
  
  const translations = useSelector(state => state.translations.value);
  return GetTranslationText(translations, id, defaultValue);
}

export function GetTranslationText(translations, id, defaultValue) {

  const label = translations?.Label?.filter(l => {
    return l.trans_lang_program_num === id;
  })[0];

  return label?.trans_lang_variable_text ?? defaultValue ?? 'NEEDS LABEL';
}

export function GetFilterTranslationText(translations, id, defaultValue) {
  const label = translations?.Filter?.filter(l => {
    return l.trans_lang_program_num === id;
  })[0];

  return label?.trans_lang_variable_text ?? defaultValue ?? 'NEEDS LABEL';
}
